export const MAP_CONSTANTS = {
  SEARCH_DEBOUNCE_MS: 300,
  BLUR_DELAY_MS: 200,
  MAP_UPDATE_DELAY_MS: 100,

  ZOOM_LEVELS: {
    DEFAULT: 4,
    SINGLE_STOP: 10,
    ROUTE: 8,
    MAX_ZOOM: 12,
  },

  MAP_PADDING: {
    TOP_LEFT: [450, 50],
    BOTTOM_RIGHT: [50, 50],
  },

  DEFAULT_CENTER: [39.8283, -98.5795],

  MIN_LABEL_DISTANCE_DIVISOR: 15,
  MIN_LABEL_DISTANCE_FLOOR: 300,

  MIN_SEARCH_QUERY_LENGTH: 3,
  MAX_SEARCH_RESULTS: 5,

  MARKER_SIZES: {
    STOP: [32, 32],
    TOLL: [24, 24],
    WEIGH_STATION: [24, 24],
  },

  ROUTE_STYLE: {
    COLOR: '#1d4ed8',
    WEIGHT: 5,
    OPACITY: 0.7,
  },

  FUEL: {
    AVERAGE_TRUCK_MPG: 6.0,
  },
};

export const US_STATES = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};
